function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        // parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  
  bindEvents() {
    super.bindEvents();
    this.querySelector('.close__icon')?.addEventListener('click', () => this.querySelector('summary').click());
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    if (customElements.get('product-gallery')) {
      const productGallery = document.getElementById(`ProductGallery-${this.dataset.section}`);
  
      if (!this.currentVariant.featured_media) {
        productGallery?.showAllMedia();
        return;
      }
  
      productGallery?.setActiveMedia(this.currentVariant.featured_media);
    } else {
      if (!this.currentVariant.featured_media) return;
  
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery?.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
      );
  
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input:not(#variant-radios-sync)')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
        
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const sizeChartPriceDestination = document.getElementById(`size-chart-product-price-${this.dataset.section}`);
        const sizeChartPriceSource = html.getElementById(
          `size-chart-product-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        const productOptionNameDestination = document.getElementById(`product-variant-options-${ this.dataset.section }`);
        const productOptionNameSource = html.getElementById(`product-variant-options-${ this.dataset.section }`);
        
        
        if (productOptionNameDestination && productOptionNameSource) {
          productOptionNameDestination.innerHTML = productOptionNameSource.innerHTML
        }

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sizeChartPriceDestination && sizeChartPriceSource) {
          sizeChartPriceDestination.innerHTML = sizeChartPriceSource.innerHTML;
        }
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Custom JS
class MMvariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.productFormSelector = `product-form--${ this.dataset.section }--${ this.dataset.pid }`;
    this.priceSelector = `price--${ this.dataset.section }--${ this.dataset.pid }`;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();
    this.updateComplementaryProductCheckbox()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductCard();
    }
  }

  updateComplementaryProductCheckbox() {    
    this.complementaryProductCheckbox = this.closest('[data-selector="marmeto-product-card"]')?.querySelector('[type="checkbox"][name="id"]'); 
       
    if (!this.complementaryProductCheckbox) return;

    this.complementaryProductCheckbox?.classList.remove('hidden')

    if (this.complementaryProductCheckbox && !this.currentVariant?.available) {
      this.complementaryProductCheckbox.classList.add('hidden')
    }

    this.complementaryProductCheckbox.value = this.currentVariant.id;
    this.complementaryProductCheckbox.dataset.price = this.currentVariant.price;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
      .map((option, index) => {
        return this.options[index] === option;
      })
      .includes(false);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll('#' + this.productFormSelector);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  async renderProductCard() {
    this.productCard = this.closest('marmeto-product-card');
    this.sectionId = this.productCard.dataset.sectionId;
    this.productHandle = this.productCard.dataset.productHandle;
    this.templateParam = this.closest('multi-product-form') ? 'card-complementary' : 'card';
    let variantUrl = `/products/${this.productHandle}?view=${this.templateParam}&variant=${this.currentVariant.id}&section=${this.sectionId}`;
  
    try {
      // Fetch the data
      const response = await fetch(variantUrl);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const responseCard = html.querySelector('marmeto-product-card');
  
      this.productCard.innerHTML = responseCard.innerHTML;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(this.productFormSelector);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(this.productFormSelector);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(this.priceSelector);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('mm-variant-selects', MMvariantSelects);

class MMvariantRadios extends MMvariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('mm-variant-radios', MMvariantRadios);

class TabbedContent extends HTMLElement {
  constructor(){
    super();

    this.tabHeaders = this.querySelector('tab-headings');
    this.tabContents = this.querySelector('tab-contents');
    if(this.tabHeaders.children.length > 0 && this.tabContents.children.length > 0){
      Array.from(this.tabHeaders.children).forEach((tab)=>{
        tab.addEventListener('click',(event)=>{
          this.openTab(event.target);
        })
      })
    }
  }

  openTab(target){
    const activeTab = target;
    Array.from(this.tabHeaders.children).forEach((tab)=>{
      if (tab.dataset.tab == activeTab.dataset.tab) {
        tab.setAttribute('data-active','')
      } else{
        tab.removeAttribute('data-active')
      }
    })

    Array.from(this.tabContents.children).forEach((tab)=> {
      if (tab.dataset.tab == activeTab.dataset.tab) {
        tab.setAttribute('data-active','')
      } else {
        tab.removeAttribute('data-active')
      }
    })
  }
}

customElements.define('tabbed-content', TabbedContent);

class InfinitePageLoader extends HTMLElement {
  constructor() {
    super();

    this.sectionID = this.dataset.section || document.querySelector('infinite-page-loader')?.dataset.section || ''
    this.collectionInnerElement = document.querySelector('#product-grid')
    this.saveScrollPoint();
    this.restoreScrollPoint();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.addObserver();
  }

  addObserver() {
    const observer = new window.IntersectionObserver(([entry]) => {

      if (entry.isIntersecting) {          
          if (entry.target == this.loadActivatorElem)
            observer.disconnect();

          var nextPageUrl = this.getNextPageUrl()

          if (nextPageUrl)
            this.loadProducts(nextPageUrl)
        }

    }, {
      root: null,
      threshold: 0.1
    })
      
    observer.observe(this)
  }

  getNextPageUrl() {
    var nextPage = parseInt(this.dataset.currentpage) + 1;

    if (nextPage > this.dataset.totalpages) {
      return false
    }

    return this.constructURLWithSearchParams(nextPage)
  }

  constructURLWithSearchParams(page) {
    var params = new URLSearchParams(document.location.search)
    var nextPage = parseInt(page) || parseInt(this.dataset.currentpage) + 1;
    var pageParam = this.dataset.pageParam || 'page'

    params.set(pageParam, nextPage)
    // params.set('filter.v.availability', 1) // To set the available products by default
    
    var searchParamsAsString = params.toString() 

    return "".concat(window.location.pathname, "?").concat(searchParamsAsString)
  }

  updateCurrentURL(url) {
    if (history.replaceState) {
      window.history.pushState({
        path: url
      }, '', url);
    }
  }

  loadProducts(url) {
    if (this.classList.contains('loading')) return;

    this.classList.add('loading')
    this.querySelector('div').classList.remove('hidden')

    this.getAndInsertHtml(url, 'append')
  }

  getAndInsertHtml(url, insertPosition) {
    var _this4 = this;

    if (this.abortController) {
      this.abortController.abort();
    }
    var currentUrl = new URL(url, window.location.href);
    currentUrl.searchParams.set('section_id', this.sectionID);

    try {
      this.abortController = new AbortController();

      fetch(currentUrl.toString(), {
        signal: this.abortController.signal
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = new DOMParser().parseFromString(content, "text/html");

          if (insertPosition == 'append') {
            //Appending new sets of product cards
            _this4.collectionInnerElement.insertAdjacentHTML('beforeend', tempElement.querySelector('#product-grid').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('infinite-page-loader').dataset.currentpage
            _this4.dataset.totalpages = tempElement.querySelector('infinite-page-loader').dataset.totalpages
          }
          else if (insertPosition == 'prepend')  {
            _this4.collectionInnerElement.insertAdjacentHTML('afterbegin', tempElement.querySelector('#product-grid').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('load-previous-page').dataset.currentpage
          }
          
          _this4.init();
          _this4.saveScrollPoint();

          _this4.classList.remove('loading')
          _this4.querySelector('div').classList.add('hidden')
        });
      });
    } catch (exception) {}
  }

  saveScrollPoint() {
      let productCards = document.querySelectorAll("marmeto-product-card");
  
      productCards.forEach((productCard) => {
        const observer = new IntersectionObserver((entries) => {
            observerCallback(entries, observer, productCard)
        },
        {threshold: 0.7});    
        observer.observe(productCard); // Observing each product card that is visible

         productCard.addEventListener('click', () => {
          sessionStorage.setItem("lastElementId", productCard.id);  
        });
      })
    
      const observerCallback = (entries, observer, header) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting && entry.target.dataset.page) {
              this.updateCurrentURL(this.constructURLWithSearchParams(entry.target.dataset.page)) //updating the url depending on the product viewed
          }
        });
      };
  }

  restoreScrollPoint() {
    // Returning if browser is safari as it gets scrolled to top after scrollIntoView method is used.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;
    
    history.scrollRestoration = "manual";
    // Reverting back to the previous element that was being viewed. 
    window.onload = function() {
      var lastElementId = sessionStorage.getItem("lastElementId");
      var lastElement = document.getElementById(lastElementId);

      if (lastElement) 
          lastElement.scrollIntoView();
          
      sessionStorage.removeItem('lastElementId'); 
    };
  }
}

customElements.define('infinite-page-loader', InfinitePageLoader);

class LoadPreviousPage extends InfinitePageLoader {
  constructor() {
    super();

    this.addEventListener('click', this.loadProducts.bind(this));
  }

  connectedCallback() {
    this.init()
  }

  init() {
    var infinitePageLoader = document.querySelector('infinite-page-loader') 
    var maxPagesLoadable = this.dataset.totalpages - 1;

    if (infinitePageLoader.dataset.currentpage - this.dataset.currentpage == maxPagesLoadable //when all the pages are loaded
      || this.dataset.currentpage == 1) { // When user is at page 1
        this.classList.add('hidden')
    } else {
      this.classList.remove('hidden')
    }
  }

  loadProducts() {
    if (this.classList.contains('loading')) return;
    
    var prevPageUrl = this.getPrevPageUrl()

    if (prevPageUrl) {
      this.classList.add('loading')
      this.getAndInsertHtml(prevPageUrl, 'prepend')
    }
  }

  getPrevPageUrl() {
    var prevPage = parseInt(this.dataset.currentpage) - 1;

    if (prevPage < 1) {
      return false
    }

    return this.constructURLWithSearchParams(prevPage)
  }
}

customElements.define('load-previous-page', LoadPreviousPage);

// custom-element.js
class MarmetoWishlist extends HTMLInputElement {
  static pendingOperations = [];

  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', this.debounce(this.handleCheckboxChange, 300));
  }

  handleCheckboxChange() {
    const value = JSON.parse(this.value);
    const [customerId, productId] = value;
    const action = this.checked ? 'add' : 'remove';
    const removeDeselectedWishlistCard = this.dataset.removeDeselectedWishlistCard == 'true';
    MarmetoWishlist.customerId = customerId; // Converting the customer ID to class variable

    if (!this.checked && removeDeselectedWishlistCard) this.removeProductCard();

    // Create an operation object
    const operation = { productId, action };

    MarmetoWishlist.pendingOperations.push(operation);
    MarmetoWishlist.handleBatchOperations();

    this.updateAllWishlistIcons();
  }

  static async handleBatchOperations(operations = MarmetoWishlist.pendingOperations) {
    if (operations.length === 0) {
      return; // No operations to perform
    }
  
    // Storing it to localStorage in case the user switches page
    localStorage.setItem('pendingWishlistOperations', JSON.stringify(operations))

    // Check if there is an ongoing network request
    if (MarmetoWishlist.abortController) {
      MarmetoWishlist.abortController.abort();
    }

    MarmetoWishlist.abortController = new AbortController();

    // Define the URL
    const deploymentId = 'AKfycbxofXo41CrTlhljyDZFjtNp8WnCZD5PKRv9O6m11kF3bSN0KI5GqD1nQqhFbwTvoXpISA'
    const url = `https://script.google.com/macros/s/${deploymentId}/exec`;
    const payloadData = {
      customerId: MarmetoWishlist.customerId,
      operations
    };

    // Create the fetch options
    const options = {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payloadData),
      signal: MarmetoWishlist.abortController.signal
    };

    // Perform the operation
    try {
      const response = await fetch(url, options);
      // Clear the pendingOperations
      localStorage.removeItem('pendingWishlistOperations')
      MarmetoWishlist.pendingOperations = [];

    } catch (error) {
      console.error(`Error in request:`, error);
    }
  }

  removeProductCard() {
    this.closest('marmeto-product-card').remove();
  }

  updateAllWishlistIcons() {
    document.querySelectorAll(`[value="${this.value}"]:not([id="${this.id}"])`).forEach(wishlistInput => {
      wishlistInput.checked = !wishlistInput.checked;
    })
  }

  debounce(func, delay) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }
}

customElements.define('marmeto-wishlist', MarmetoWishlist, { extends: 'input' });

if (localStorage.getItem('pendingWishlistOperations')) {
  MarmetoWishlist.handleBatchOperations(JSON.parse(localStorage.getItem('pendingWishlistOperations')))
}

class MarmetoDrawer extends HTMLDialogElement {
  constructor() {
      super();

      this.toggleClass = this.dataset.toggleClass?.split(' ');
      this.closeSelector = this.dataset.closeSelector;
  }

  connectedCallback() {
      this.closeButton = this.querySelector(this.closeSelector)

      this.closeButton.addEventListener('click', this.closeDialog.bind(this));

      // Close the dialog when clicking outside
      this.addEventListener('click', this.closeDialog.bind(this))
  }

  openDialog() {
      this.showModal();
      document.body.classList.add('overflow-hidden')
      this.toggleClass.forEach(selector => this.classList.remove(selector))
  }

  closeDialog() {
      if (event && event.target != this && event.target != this.closeButton) return;

      document.body.classList.remove('overflow-hidden')
      this.toggleClass.forEach(selector => this.classList.add(selector))

      // Close the dialog after the animation is completed
      setTimeout(() => {
          this.close();
      }, 300);
  }
}

customElements.define('marmeto-drawer', MarmetoDrawer, { extends: 'dialog' });

class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
    this.shimmerContainer = this.querySelector(".skeleton-container");
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;
      
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      // Default to intersection observer. Fetch ahead of the viewport so the
      // placeholder is swapped for real content before it scrolls into view (CLS).
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 800px 0px' }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    if (this.shimmerContainer) {
      this.shimmerContainer.classList.remove("hidden");
    }
    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

      // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort();
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.innerHTML = sectionContent.innerHTML;

              // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          } else {
            // Section rendered nothing: drop the reserved placeholder height.
            LazySection.releasePlaceholder(key);
          }
        }

        if (this.shimmerContainer) {
          this.shimmerContainer.classList.add("hidden");
        }

        if (sectionsToFetchBatch.length < 5)
          LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
        // Aborted batches are re-requested by the next fetch; on a real failure, don't leave blank space.
        if (e.name !== 'AbortError') sectionsToFetchBatch.forEach(LazySection.releasePlaceholder);
      });
  }

  static releasePlaceholder(sectionId) {
    const placeholder = document.getElementById('shopify-section-' + sectionId)?.querySelector('lazy-section');
    if (placeholder) placeholder.style.minHeight = '0';
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}

customElements.define('lazy-section', LazySection);

//Event listener to show the mobile nav bar on scroll down and hide it on scroll up
let lastScrollTop = 0;

window.addEventListener("scroll", function() {
  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const footerBottomEl = document.querySelector(".footer__content-bottom");
  const mobNavSticky = document.querySelector('.mob__nav__container');
  
  if (!footerBottomEl || !mobNavSticky) return;

  if (currentScrollTop > lastScrollTop) {
    mobNavSticky.classList.remove('animate');
    footerBottomEl.style.paddingBottom = `${mobNavSticky.offsetHeight}px`;
  } else {
    mobNavSticky.classList.add('animate');
    footerBottomEl.style.paddingBottom = `${mobNavSticky.offsetHeight}px`;
  }

  lastScrollTop = currentScrollTop;
});

// Section rendering for product card variants
class ProductCardVariant extends HTMLElement {
  constructor() {
    super();
    this.variantHandle = this.dataset.variantHandle;
    this.sectionId = this.dataset.sectionId;
    this.variantId = this.dataset.variantId;
    this.addEventListener("click", this.onVariantClick);
  }

  onVariantClick() {
    const url = `/products/${this.variantHandle}/${this.variantId}?view=custom-product-card-render`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.closest("marmeto-product-card").innerHTML = html.querySelector("marmeto-product-card").innerHTML
      })
      .catch((error)=>{
        console.error('Error fetching data:', error);
      });
  }
}

customElements.define("product-card-variant", ProductCardVariant);

class drawerFlow extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 0;
    this.totalSteps = parseInt(this.dataset.totalSteps) || 5;
    this.selectedLensType = '';
    this.selectedLensTypeLabel = '';
    this.selectedVariantId = '';
    this.isSkipAddOn = false;
    this.addOnAdded = false;
    this.addOnProductId = '';
    this.addOnProductPrice = '';
    this.addOnProductPriceFormatted = '';
    this.addOnProductTitle = '';
  }

  connectedCallback() {
    this.initializeVariables();
  }

  initializeVariables() {
    if (this._initialized) return;
    this._initialized = true;
    
    // Overlay
    this.overlay = this.querySelector('drawer-flow-overlay');
    // Steps
    this.steps = this.querySelectorAll('.drawer-flow__step');
    // Close buttons
    this.closeBtns = this.querySelectorAll('.drawer-flow__close-btn');
    // Back buttons
    this.backBtns = this.querySelectorAll('.drawer-flow__back-btn');
    // Progress bars
    this.progressBars = this.querySelectorAll('.drawer-flow__progress-bar');
    // Step 1: Lens Type
    this.lensTypeBtns = this.querySelectorAll('.drawer-flow__lens-type-btn');
    // Step 2: Lens Variant
    this.variantItems = this.querySelectorAll('.drawer-flow__variant-item');
    this.variantBtns = this.querySelectorAll('.drawer-flow__variant-btn');
    // Step 3: Add-ons
    this.addonItems = this.querySelectorAll('.drawer-flow__addon-item');
    this.addonAddBtns = this.querySelectorAll('.drawer-flow__addon-add-btn');
    this.skipBtn = this.querySelector('.drawer-flow__skip-btn');
    this.subtotalValue = this.querySelector('.drawer-flow__subtotal-value');
    this.noAddonsContainer = this.querySelector('.drawer-flow__no-addons');
    this.addonListContainer = this.querySelector('.drawer-flow__addon-list');
    // Step 4: Prescription Selection
    this.subtotalPrescription = this.querySelector('.drawer-flow__subtotal-prescription');
    this.manualFormBtn = this.querySelector('.drawer-flow__manual-form-btn');
    this.uploadPhotoBtn = this.querySelector('.drawer-flow__upload-photo-btn');
    this.proceedBtn = this.querySelector('.drawer-flow__proceed-btn');
    // Step 5: Manual Rx Form
    this.submitRxBtn = this.querySelector('.drawer-flow__submit-rx-btn');
    this.addFields = this.querySelectorAll('.drawer-flow__field--add');
    // Step 6: Upload Prescription
    this.uploadDropzone = this.querySelector('#upload-dropzone');
    this.uploadFileInput = this.querySelector('#drawer-file-input-upload');
    this.uploadPreview = this.querySelector('#upload-preview');
    this.uploadFileName = this.querySelector('#upload-file-name');
    this.uploadFileSize = this.querySelector('#upload-file-size');
    this.uploadRemoveBtn = this.querySelector('#upload-remove-btn');
    this.uploadError = this.querySelector('#upload-error');
    this.uploadErrorMsg = this.querySelector('#upload-error-msg');
    this.uploadSubmitBtn = this.querySelector('.drawer-flow__upload-submit-btn');
    // Hidden form fields
    this.finalProductForm = this.querySelector('.drawer-flow__final-form product-form');
    this.fileInput = this.querySelector('#drawer-file-input');
    this.powerTypeInput = this.querySelector('.custom-atc-power-type');
    this.mainProductIdInput = this.querySelector('#main-product-id');
    this.timestamp = this.querySelector('#timestamp');
    this.addOnProductDetails = this.querySelector('#add-on-product');
    this.addOnValidation = this.querySelector('#add-on-validation');
    this.prescriptionDataInput = this.querySelector('#prescription-data');
    this.finalAtcBtn = this.querySelector('.drawer-flow__final-atc-btn');
    this.continueWrap = this.querySelector('.drawer-flow__continue-wrap');
    this.continueBtn = this.querySelector('.drawer-flow__continue-btn');

    // Bind events
    if (this.continueBtn) {
      this.continueBtn.addEventListener('click', () => {
        if (this.selectedVariantId) {
          const variantBtn = Array.from(this.variantBtns).find(btn => btn.dataset.variantId === this.selectedVariantId);
          const variantTitle = variantBtn ? variantBtn.dataset.variantTitle : '';
          
          if (variantTitle && variantTitle.toLowerCase() === 'ultra thin blux') {
            this.isSkipAddOn = true;
            this.goToStep(4);
          } else {
            this.isSkipAddOn = false;
            this.filterAddons();
            this.goToStep(3);
          }
        }
      });
    }

    this.closeBtns.forEach(btn => btn.addEventListener('click', this.close.bind(this)));
    this.backBtns.forEach(btn => btn.addEventListener('click', this.goBack.bind(this)));
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    // Step 1: Lens type selection — highlight selected + navigate
    this.lensTypeBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const target = e.currentTarget;
        this.selectedLensType = target.dataset.categoryName;
        this.selectedLensTypeLabel = target.dataset.categoryLabel;

        // Highlight selected lens type
        this.lensTypeBtns.forEach(b => b.classList.remove('selected'));
        target.classList.add('selected');

        this.filterVariants();
        this.toggleAddFields();
        this.goToStep(2);
      });
    });

    // Step 2: Variant selection
    this.variantBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const target = e.currentTarget;
        if (target.disabled) return;
        this.selectedVariantId = target.dataset.variantId;
        const variantPrice = target.dataset.variantPrice;
        const variantTitle = target.dataset.variantTitle;

        // Update power type input
        if (this.powerTypeInput) {
          this.powerTypeInput.value = this.selectedVariantId;
        }

        // Update subtotals
        if (this.subtotalValue) {
          this.subtotalValue.innerHTML = variantPrice;
          this.subtotalValue.dataset.addonPrice = target.dataset.variantPriceRaw;
        }
        if (this.subtotalPrescription) {
          this.subtotalPrescription.innerHTML = variantPrice;
        }

        // Mark selected
        this.variantBtns.forEach(b => b.closest('.drawer-flow__variant-item')?.classList.remove('selected'));
        target.closest('.drawer-flow__variant-item')?.classList.add('selected');

        // Check if variant should skip add-ons (ultra thin blux)
        if (variantTitle && variantTitle.toLowerCase() === 'ultra thin blux') {
          this.isSkipAddOn = true;
          if (!this.isBannerFlow || e.isTrusted) this.goToStep(4);
        } else {
          this.isSkipAddOn = false;
          this.filterAddons();
          if (!this.isBannerFlow || e.isTrusted) this.goToStep(3);
        }
      });
    });

    // Step 3: Add-on card selection (click entire card to select/deselect)
    this.addonItems.forEach(item => {
      item.addEventListener('click', (e) => {
        // Skip if out-of-stock
        if (item.classList.contains('out-of-stock')) return;

        const btn = item.querySelector('.drawer-flow__addon-add-btn');
        if (!btn || btn.disabled) return;

        const isSelected = item.classList.contains('selected');

        // Deselect all other addon items first
        this.addonItems.forEach(i => i.classList.remove('selected'));

        if (isSelected) {
          // Deselect — clear add-on
          this.clearAddOns();
        } else {
          // Select this add-on
          item.classList.add('selected');
          this.addOnProductId = btn.dataset.addOnProductId;
          this.addOnProductPrice = btn.dataset.productPrice;
          this.addOnProductPriceFormatted = btn.dataset.addOnPrice;
          this.addOnProductTitle = btn.dataset.addOnProductTitle;

          if (this.finalAtcBtn) {
            this.finalAtcBtn.setAttribute('add-ons', true);
            this.finalAtcBtn.setAttribute('add-on-product-id', this.addOnProductId);
          }
          this.addOnAdded = true;

          this.updatePrescriptionSubtotal();
          this.goToStep(4);
        }
      });
    });

    // Skip add-ons
    if (this.skipBtn) {
      this.skipBtn.addEventListener('click', () => {
        this.clearAddOns();
        this.clearFormData();
        this.goToStep(4);
      });
    }

    // Step 4: Prescription selection — two card options
    if (this.manualFormBtn) {
      this.manualFormBtn.addEventListener('click', () => this.goToStep(5));
    }
    if (this.uploadPhotoBtn) {
      this.uploadPhotoBtn.addEventListener('click', () => this.goToStep(6));
    }

    // Proceed button (prescription step)
    if (this.proceedBtn) {
      this.proceedBtn.addEventListener('click', (e) => {
        // Prevent default form submit - let product-form handle it
      });
    }

    // Step 5: Submit Rx
    if (this.submitRxBtn) {
      this.submitRxBtn.addEventListener('click', () => {
        this.collectPrescriptionData();
        if (this.manualFormBtn) {
          if (this.prescriptionDataInput && this.prescriptionDataInput.value.trim() !== '') {
            this.manualFormBtn.classList.add('selected');
          } else {
            this.manualFormBtn.classList.remove('selected');
          }
        }
        if (this.finalAtcBtn) {
          this.finalAtcBtn.click();
        } else {
          this.goToStep(4);
        }
      });
    }

    // Step 6: Upload Prescription — drag-and-drop + file picker
    this.initUploadDrawer();

    // Proceed btn click -> close drawer and finalize
    if (this.finalAtcBtn) {
      this.finalAtcBtn.addEventListener('click', () => {
        this.close();
        this.initializeFormData();
      });
    }
  }

  /* ---- Upload Drawer (Step 6) ---- */
  initUploadDrawer() {
    if (!this.uploadDropzone) return;

    // Click to browse
    this.uploadDropzone.addEventListener('click', (e) => {
      if (e.target.closest('label')) {
        return; // Let browser handle label click natively
      }
      if (e.target === this.uploadDropzone || e.target.closest('.drawer-flow__upload-dropzone-inner')) {
        this.uploadFileInput.click();
      }
    });

    this.uploadFileInput.addEventListener('click', (e) => {
      e.target.value = ''; // Guarantee 'change' event fires even if same file is re-selected
    });

    // File input change
    this.uploadFileInput.addEventListener('change', () => {
      if (this.uploadFileInput.files.length) {
        this.handleUploadFile(this.uploadFileInput.files[0]);
      }
    });

    // Drag events
    ['dragenter', 'dragover'].forEach(evt => {
      this.uploadDropzone.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.uploadDropzone.classList.add('drag-over');
      });
    });
    ['dragleave', 'drop'].forEach(evt => {
      this.uploadDropzone.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.uploadDropzone.classList.remove('drag-over');
      });
    });
    this.uploadDropzone.addEventListener('drop', (e) => {
      const files = e.dataTransfer.files;
      if (files.length) {
        this.handleUploadFile(files[0]);
      }
    });

    // Remove file
    if (this.uploadRemoveBtn) {
      this.uploadRemoveBtn.addEventListener('click', () => {
        this.clearUploadFile();
      });
    }

    // Submit uploaded file
    if (this.uploadSubmitBtn) {
      this.uploadSubmitBtn.addEventListener('click', () => {
        // Copy the file to the main hidden file input so the form submits it
        if (this.uploadFileInput.files.length && this.fileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(this.uploadFileInput.files[0]);
          this.fileInput.files = dataTransfer.files;
        }
        if (this.uploadPhotoBtn) this.uploadPhotoBtn.classList.add('selected');
        if (this.finalAtcBtn) {
          this.finalAtcBtn.click();
        } else {
          this.goToStep(4);
        }
      });
    }
  }

  handleUploadFile(file) {
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    const ext = file.name.split('.').pop().toLowerCase();

    // Hide error
    if (this.uploadError) this.uploadError.classList.add('hidden');

    if (!allowedExtensions.includes(ext)) {
      if (this.uploadError) {
        this.uploadErrorMsg.textContent = 'Invalid file type. Please upload JPG, JPEG, PNG, or PDF.';
        this.uploadError.classList.remove('hidden');
      }
      return;
    }

    if (file.size === 0) {
      if (this.uploadError) {
        this.uploadErrorMsg.textContent = 'The selected file is empty. Please upload a valid file.';
        this.uploadError.classList.remove('hidden');
      }
      return;
    }

    // Show preview
    if (this.uploadFileName) this.uploadFileName.textContent = file.name;
    if (this.uploadFileSize) {
      const sizeKB = (file.size / 1024).toFixed(1);
      this.uploadFileSize.textContent = sizeKB > 1024 ? (sizeKB / 1024).toFixed(1) + ' MB' : sizeKB + ' KB';
    }
    if (this.uploadDropzone) this.uploadDropzone.classList.add('hidden');
    if (this.uploadPreview) this.uploadPreview.classList.remove('hidden');
    if (this.uploadSubmitBtn) this.uploadSubmitBtn.disabled = false;

    // Set file to internal input
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    this.uploadFileInput.files = dataTransfer.files;
  }

  clearUploadFile() {
    if (this.uploadFileInput) this.uploadFileInput.value = '';
    if (this.uploadDropzone) this.uploadDropzone.classList.remove('hidden');
    if (this.uploadPreview) this.uploadPreview.classList.add('hidden');
    if (this.uploadError) this.uploadError.classList.add('hidden');
    if (this.uploadSubmitBtn) this.uploadSubmitBtn.disabled = true;
    // Clear the main file input too
    if (this.fileInput) this.fileInput.value = '';
    if (this.uploadPhotoBtn) this.uploadPhotoBtn.classList.remove('selected');
  }

  /* ---- Progress Bar ---- */
  updateProgressBar(stepIndex) {
    // Map actual step number to logical progress (1-5)
    // Steps 5 and 6 both count as step 5 (final) in the progress bar
    let logicalStep = stepIndex;
    if (stepIndex === 6) logicalStep = 5;

    const percent = (logicalStep / this.totalSteps) * 100;

    this.progressBars.forEach(bar => {
      const fill = bar.querySelector('.drawer-flow__progress-fill');
      const text = bar.querySelector('.drawer-flow__progress-text');
      if (fill) fill.style.width = percent + '%';
      if (text) text.textContent = `Step ${logicalStep} of ${this.totalSteps}`;
    });
  }

  open(productId, productPrice, preselectVariant = null) {
    // Reset state
    this.currentStep = 1;
    this.isBannerFlow = false;
    if (this.continueWrap) this.continueWrap.style.display = 'none';
    this.selectedLensType = '';
    this.selectedLensTypeLabel = '';
    this.selectedVariantId = '';
    this.isSkipAddOn = false;
    this.resetAllSteps();
    this.clearAddOns();
    this.clearUploadFile();

    // Clear prescription data
    if (this.prescriptionDataInput) this.prescriptionDataInput.value = '';
    if (this.fileInput) this.fileInput.value = '';

    // Set product info
    if (productId) {
      if (this.powerTypeInput) this.powerTypeInput.value = productId;
      if (this.mainProductIdInput) this.mainProductIdInput.value = productId;
      const mainProdInputs = this.querySelectorAll('#main-product-id, [name="properties[main-product-id]"]');
      mainProdInputs.forEach(input => input.value = productId);
      if (this.addonListContainer) {
        this.addonListContainer.setAttribute('data-product-id', productId);
      }
    }
    if (this.subtotalPrescription && productPrice) {
      this.subtotalPrescription.innerHTML = productPrice;
    }

    // Reset all selections (lens type, variant, add-on)
    this.lensTypeBtns.forEach(btn => btn.classList.remove('selected'));
    this.variantBtns.forEach(btn => {
      const item = btn.closest('.drawer-flow__variant-item');
      if (item) item.classList.remove('selected');
      if (btn.dataset.variantAvailable === 'true') {
        btn.disabled = false;
      }
    });
    this.addonItems.forEach(item => item.classList.remove('selected'));
    if (this.manualFormBtn) this.manualFormBtn.classList.remove('selected');
    if (this.uploadPhotoBtn) this.uploadPhotoBtn.classList.remove('selected');

    // Show step 1 (Lens Type Selection)
    this.showStep(1);
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    // Handle preselection
    if (preselectVariant) {
      this.isBannerFlow = true;
      if (this.continueWrap) this.continueWrap.style.display = 'block';
      setTimeout(() => {
        const variantBtnToPreselect = Array.from(this.variantBtns).find(btn => {
          return btn.dataset.variantTitle && btn.dataset.variantTitle.trim().toLowerCase() === preselectVariant.toLowerCase();
        });

        if (variantBtnToPreselect && !variantBtnToPreselect.disabled) {
          // 1. Find the category of this variant
          const variantItem = variantBtnToPreselect.closest('.drawer-flow__variant-item');
          if (variantItem && variantItem.dataset.category) {
            const category = variantItem.dataset.category;
            // 2. Select this category in step 1
            const categoryBtn = Array.from(this.lensTypeBtns).find(btn => btn.dataset.categoryName === category);
            if (categoryBtn) {
              categoryBtn.click();
              
              // 3. Click the variant button itself
              setTimeout(() => {
                variantBtnToPreselect.click();
              }, 50);
            }
          }
        }
      }, 50);
    }
  }

  openDirect() {
    // For custom template products: go straight to prescription
    this.currentStep = 4;
    this.resetAllSteps();
    this.clearAddOns();
    this.clearUploadFile();

    if (this.prescriptionDataInput) this.prescriptionDataInput.value = '';
    if (this.fileInput) this.fileInput.value = '';
    if (this.manualFormBtn) this.manualFormBtn.classList.remove('selected');
    if (this.uploadPhotoBtn) this.uploadPhotoBtn.classList.remove('selected');

    this.showStep(4);
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.resetAllSteps();
  }

  resetAllSteps() {
    this.steps.forEach(step => step.classList.remove('active'));
  }

  showStep(stepIndex) {
    this.resetAllSteps();
    const step = this.querySelector(`[data-step="${stepIndex}"]`);
    if (step) {
      step.classList.add('active');
      this.currentStep = stepIndex;
      this.updateProgressBar(stepIndex);
    }
  }

  goToStep(stepIndex) {
    this.showStep(stepIndex);
  }

  goBack() {
    if (this.currentStep === 6) {
      // From upload drawer back to prescription selection
      this.clearUploadFile();
      this.goToStep(4);
    } else if (this.currentStep === 5) {
      // From manual form back to prescription selection
      this.goToStep(4);
    } else if (this.currentStep === 4) {
      // From prescription back — keep selections, just clear add-ons if skipped
      if (this.isSkipAddOn) {
        this.clearAddOns();
        this.isSkipAddOn = false;
        this.goToStep(2); // variant still highlighted
      } else {
        this.goToStep(3);
      }
    } else if (this.currentStep === 3) {
      // From add-ons back to variants — keep variant selection visible
      this.clearAddOns();
      this.goToStep(2); // variant highlight preserved
    } else if (this.currentStep === 2) {
      // From variants back to lens type — lens type highlight preserved
      this.goToStep(1);
    } else if (this.currentStep === 1) {
      // Step 1 is first step — close drawer
      this.close();
    } else {
      this.close();
    }
  }

  filterVariants() {
    this.variantItems.forEach(item => {
      if (item.dataset.category === this.selectedLensType) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }

  filterAddons() {
    let hasAddons = false;
    this.addonItems.forEach(item => {
      if (item.dataset.variantId == this.selectedVariantId) {
        hasAddons = true;
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
    if (this.noAddonsContainer) {
      if (!hasAddons) {
        this.noAddonsContainer.classList.remove('hidden');
      } else {
        this.noAddonsContainer.classList.add('hidden');
      }
    }
  }

  toggleAddFields() {
    const isProgressive = this.selectedLensType.includes('progressive');
    this.addFields.forEach(field => {
      if (isProgressive) {
        field.classList.remove('hidden');
      } else {
        field.classList.add('hidden');
      }
    });
  }

  clearAddOns() {
    this.addOnAdded = false;
    if (this.finalAtcBtn) {
      this.finalAtcBtn.removeAttribute('add-ons');
      this.finalAtcBtn.removeAttribute('add-on-product-id');
    }
    // Remove selected state from all addon cards
    this.addonItems.forEach(item => item.classList.remove('selected'));
    // Reset subtotal
    if (this.subtotalPrescription && this.subtotalValue) {
      this.subtotalPrescription.innerHTML = this.subtotalValue.innerHTML;
    }
  }

  clearFormData() {
    if (this.mainProductIdInput) this.mainProductIdInput.value = '';
    if (this.timestamp) this.timestamp.value = '';
    if (this.addOnProductDetails) this.addOnProductDetails.value = '';
    if (this.addOnValidation) this.addOnValidation.value = '';
  }

  initializeFormData() {
    if (this.timestamp) this.timestamp.value = this.getTimestamp();
    if (this.addOnProductDetails) {
      this.addOnProductDetails.value = this.addOnAdded ? (this.addOnProductTitle + '||' + this.addOnProductPriceFormatted) : '';
    }
    if (this.addOnValidation) this.addOnValidation.value = this.addOnAdded ? 'true' : '';
  }

  getTimestamp() {
    const addonsStr = this.addOnProductId ? `${this.addOnProductId}` : '';
    const rxStr = this.prescriptionDataInput ? this.prescriptionDataInput.value : '';
    const fileStr = (this.uploadFileInput && this.uploadFileInput.files.length > 0) ? this.uploadFileInput.files[0].name : '';
    const str = `${addonsStr}-${rxStr}-${fileStr}`;
    
    let hash = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        let chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return 'config_' + Math.abs(hash).toString(16);
  }

  updatePrescriptionSubtotal() {
    if (!this.subtotalValue || !this.subtotalPrescription) return;
    const currentPrice = parseFloat(this.subtotalValue.dataset.addonPrice);
    const addOnPrice = parseFloat(this.addOnProductPrice);
    if (isNaN(currentPrice) || isNaN(addOnPrice)) return;

    const total = currentPrice + addOnPrice;
    const currencySymbol = this.subtotalValue.innerHTML.trim().charAt(0);
    const formatted = total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.subtotalPrescription.innerHTML = `${currencySymbol}${formatted}`;
  }

  collectPrescriptionData() {
    const rSph = this.querySelector('#rx-right-sph')?.value || '';
    const rCyl = this.querySelector('#rx-right-cyl')?.value || '';
    const rAx = this.querySelector('#rx-right-ax')?.value || '';
    const rAdd = this.querySelector('#rx-right-add')?.value || '';
    
    const lSph = this.querySelector('#rx-left-sph')?.value || '';
    const lCyl = this.querySelector('#rx-left-cyl')?.value || '';
    const lAx = this.querySelector('#rx-left-ax')?.value || '';
    const lAdd = this.querySelector('#rx-left-add')?.value || '';
    
    const pd = this.querySelector('#rx-pd')?.value || '';

    let formatted = [];
    
    if (rSph || rCyl || rAx || rAdd) {
      formatted.push(`Right Eye: SPH(${rSph || '-'}), CYL(${rCyl || '-'}), AX(${rAx || '-'}), ADD(${rAdd || '-'})`);
    }
    if (lSph || lCyl || lAx || lAdd) {
      formatted.push(`Left Eye: SPH(${lSph || '-'}), CYL(${lCyl || '-'}), AX(${lAx || '-'}), ADD(${lAdd || '-'})`);
    }
    if (pd) {
      formatted.push(`PD: ${pd}`);
    }

    if (this.prescriptionDataInput) {
      this.prescriptionDataInput.value = formatted.length > 0 ? formatted.join(' | ') : '';
    }
  }
}

customElements.define("drawer-flow", drawerFlow);

class customAtcDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeVariables();
  }

  initializeVariables() {
    this.customAtcButton = this.querySelector(".custom-atc-button");
    if (!this.customAtcButton) return;
    this.customAtcButton.addEventListener("click", () => {
      this.customProductTemplate = this.dataset.customProductTemplate;
      if (this.customProductTemplate) {
        this.showDrawerDirect();
      } else {
        this.showDrawer();
      }
    });
  }

  showDrawer() {
    const drawer = document.querySelector("drawer-flow");
    if (!drawer) return;
    if (!this.customAtcButton) return;
    const productId = this.customAtcButton.dataset.productId;
    const productPrice = this.customAtcButton.dataset.productPrice;
    const preselectVariant = this.customAtcButton.dataset.preselectVariant || null;
    drawer.open(productId, productPrice, preselectVariant);
  }

  showDrawerDirect() {
    const drawer = document.querySelector("drawer-flow");
    if (!drawer) return;
    drawer.openDirect();
  }
}

customElements.define("custom-atc-drawer", customAtcDrawer);

const firstAccordion = document.querySelector('.product__info-container .product__accordion details');
// if (firstAccordion) {
//   firstAccordion.setAttribute('open', '');
// }

if (!customElements.get("offers-popup")) {
  class OffersPopup extends HTMLElement {
    connectedCallback() {
      const popup = this.querySelector('.offers-popup');
      const openBtn = this.querySelector('.view-all-offers-btn');
      const closeBtn = this.querySelector('.close-popup');
      const toggleButtons = this.querySelectorAll('.toggle-details');
      const detailSections = this.querySelectorAll('.offer-details');
      const copyButtons = this.querySelectorAll('.copy-code-btn');
  
      if (!popup || !openBtn || !closeBtn || toggleButtons.length === 0) return;
  
      openBtn.addEventListener('click', () => {
        popup.classList.add('open');
        document.body.classList.add('body-overflow-hidden');
        document.querySelector("cart-drawer-items").classList.add('overflow-hidden');
        document.querySelector(".drawer__inner").classList.add('overflow-hidden');
      });
  
      closeBtn.addEventListener('click', () => {
        popup.classList.remove('open');
        document.body.classList.remove('body-overflow-hidden');
        document.querySelector("cart-drawer-items").classList.remove('overflow-hidden');
        document.querySelector(".drawer__inner").classList.remove('overflow-hidden');
        this.closeAllDetails(detailSections);
      });

      popup.addEventListener('click', (e) => {
        const popupContent = this.querySelector('.offers-popup-content');
        if (!popupContent.contains(e.target)) {
          popup.classList.remove('open');
          document.body.classList.remove('body-overflow-hidden');
          document.querySelector("cart-drawer-items").classList.remove('overflow-hidden');
          document.querySelector(".drawer__inner").classList.remove('overflow-hidden');
          this.closeAllDetails(detailSections);
        }
      });
  
      toggleButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.nextElementSibling;
          if (!target || !target.classList.contains('offer-details')) return;
  
          const isVisible = target.classList.contains('visible');
  
          this.closeAllDetails(detailSections);
  
          if (!isVisible) {
            target.classList.add('visible');
            target.style.maxHeight = target.scrollHeight + 'px';
          }
        });
      });

      copyButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const code = btn.closest('.offer-code-box')?.dataset.code;
          if (code) {
            navigator.clipboard.writeText(code).then(() => {
              btn.innerText = 'Copied!';
              setTimeout(() => (btn.innerText = 'Copy'), 1500);
            });
          }
        });
      });
    }
  
    closeAllDetails(sections) {
      sections.forEach(section => {
        section.classList.remove('visible');
        section.style.maxHeight = null;
      });
    }
  }
  
  customElements.define('offers-popup', OffersPopup);
}

class FeedbackForm extends HTMLElement {
  constructor() {
    super();
    this.formWrapper = this.querySelector(".feedback-form__wrapper");
    this.form = this.querySelector(".feedback-form__form");
    this.inputElementsList = this.querySelectorAll('.feedback-form__form input');
    this.textAreaElementsList = this.querySelectorAll('.feedback-form__form textarea');
    this.submitButton = this.querySelector(".feedback-form__submit-button");
    this.spinnerWrapper = this.querySelector(".feedback-form__spinner-wrapper");
    this.submitResponse = this.querySelector(".feedback-form__submit-response-wrapper");
    this.errorMessage = this.querySelector(".feedback-form__error-message");
    this.appointmentText = this.querySelector(".hto-submission-text");

    this.form.addEventListener('submit', this.sendDataToGoogleSheet.bind(this));
  }

  connectedCallback() {
    const htoSubmitted = sessionStorage.getItem('htoSubmitted');

    if (htoSubmitted === 'true') {
      this.appointmentText.classList.remove('hidden');
    }else {
      this.appointmentText.classList.add('hidden');
    }
  }

  sendDataToGoogleSheet(event) {
    event.preventDefault();
    this.spinnerWrapper.classList.remove('hide-loader');
    const url = "https://script.google.com/macros/s/AKfycbzLKbeBBIPYxw76VKWSXEyVAl2ZFk1H1Av-huwN819CCB0_L5b0aBYNSzz5skTxHMbl/exec";

    const formData = new FormData();
    
    if (this.inputElementsList) {
      this.inputElementsList.forEach((inputElement) => {
        formData.append(inputElement.name, inputElement.value.trim());
      });
    }

    if (this.textAreaElementsList) {
      this.textAreaElementsList.forEach((textAreaEl) => {
        formData.append(textAreaEl.name, textAreaEl.value.trim());
      })
    }

    try {
      fetch(url, {
        method: 'POST',
        body: formData
      }).then(response => {
        if (response.ok) {
          this.formWrapper.classList.add("hide-form-wrapper");
          this.spinnerWrapper.classList.add('hide-loader');
          this.submitResponse.classList.remove("hide-submit-status");
          setTimeout(() => {
            window.location.replace(document.referrer || '/');
          }, 3000);
        } 
        else {
          this.spinnerWrapper.classList.add('hide-loader');
          this.errorMessage.textContent = "Something went wrong. Please try again.";
          console.error('Error in response:', response.statusText);
        }
      });
    } catch (error) {
      this.spinnerWrapper.classList.add('hide-loader');
      this.errorMessage.textContent = "Something went wrong! failed to submit your feedback";
      console.error('Error sending data:', error);
    }
  }
}

customElements.define('feedback-form', FeedbackForm);

document.addEventListener('DOMContentLoaded', function(){
  const htoFeedbackText = document.querySelector(".feedback-form__wrapper.no-form");
  if(!htoFeedbackText) return;
  
  const feedbackText = htoFeedbackText.querySelector('.hto-submission-text');
  const htoSubmitted = sessionStorage.getItem('htoSubmitted');

  if (htoSubmitted === 'true') {
    feedbackText.classList.remove('hidden');
  }else {
    feedbackText.classList.add('hidden');
  }
})

document.addEventListener('DOMContentLoaded', function () {
  const pincodePopup = document.getElementById("PopupModal-capture-pincode");
  if (!pincodePopup) return;

  const pincodeInput = pincodePopup.querySelector("#user-pincode");
  const submitButton = pincodePopup.querySelector("#submit-pincode");
  const errorMessage = pincodePopup.querySelector(".pincode-input-error");

  const storageKey = "userPincode";
  const sessionSendKey = "pincodeSentThisSession";

  const expiryDays = pincodePopup.dataset.expiryDays;
  const expiryTime = expiryDays * 24 * 60 * 60 * 1000;

  function getStoredPincode() {
    const data = localStorage.getItem(storageKey);
    if (!data) return null;

    try {
      const parsed = JSON.parse(data);
      const now = Date.now();

      if (now - parsed.timestamp > expiryTime) {
        localStorage.removeItem(storageKey);
        sessionStorage.removeItem(sessionSendKey);
        return null;
      }
      return parsed.pincode;
    } catch {
      localStorage.removeItem(storageKey);
      sessionStorage.removeItem(sessionSendKey);
      return null;
    }
  }

  function storePincode(pincode) {
    localStorage.setItem(storageKey, JSON.stringify({
      pincode,
      timestamp: Date.now()
    }));
  }

  // ---- Function to send to Google Sheet ----
  function sendPincodeToSheet(pincode) {
    if (sessionStorage.getItem(sessionSendKey)) return;

    sessionStorage.setItem(sessionSendKey, "true");

    const mobileNumber = localStorage.getItem('userMobileNumber');
    const pageType = pincodePopup.dataset.pageType;
    const pageName = pincodePopup.dataset.pageName || 'default';

    const googleSheetUrl = 'https://script.google.com/macros/s/AKfycbyRQbo76P5FrFifLmeg0_tVhCtJ1mNN6O8-de_g-07V5Mph5tFJGlit_s1S24emQ_l0/exec';

    const data = {
      pincode: pincode,
      countryCode: `${mobileNumber ? '91' : ""}`,
      mobileNumber: mobileNumber,
      pageType: pageType,
      pageName: pageName
    };

    fetch(googleSheetUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      console.log('Pincode details sent to Google Sheet successfully.');
    })
    .catch(error => {
      console.error('Error sending pincode details to Google Sheet:', error);
    });
  }

  // ---- On Page Load ----
  const storedPincode = getStoredPincode();

  if (storedPincode) {
    // valid pincode exists
    sendPincodeToSheet(storedPincode);
  } else {
    // no valid pincode → show popup
    pincodePopup.setAttribute("open", true);
    pincodeInput.focus();
  }

  // Prevent ESC closing
  document.addEventListener("keydown", (e) => {
    if (pincodePopup.hasAttribute("open") && e.key === "Escape") {
      e.preventDefault();
    }
  });

  pincodeInput.addEventListener("input", () => {
    errorMessage.classList.add("hidden");
  });

  const validatePincode = (value) => /^[1-9]{1}[0-9]{5}$/.test(value);

  submitButton.addEventListener("click", () => {
    const pincodeValue = pincodeInput.value.trim();
    errorMessage.classList.add("hidden");

    if (!validatePincode(pincodeValue)) {
      errorMessage.classList.remove("hidden");
      return;
    }

    submitButton.classList.add("loading");
    submitButton.disabled = true;

    setTimeout(() => {
      storePincode(pincodeValue);
      sendPincodeToSheet(pincodeValue); // send immediately once
      pincodePopup.removeAttribute("open");
    }, 600);
  });

  pincodeInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") submitButton.click();
  });
});

// sticky PDP mobile buttons js
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 767) return;

  const buttonContainer = document.querySelector('.custom-buy-buttons-container');

  if (!buttonContainer) return;

  const placeholder = document.createElement('div');
  placeholder.style.height = `${buttonContainer.offsetHeight}px`;
  placeholder.style.display = 'none';

  buttonContainer.parentNode.insertBefore(
    placeholder,
    buttonContainer.nextSibling
  );

  const initialTop =
    buttonContainer.getBoundingClientRect().top + window.scrollY;

  let isSticky = false;

  const TOP_STICKY = 80;
  const showStickyAt = initialTop + buttonContainer.offsetHeight;
  const hideStickyAt = initialTop - 500;

  function makeSticky() {
    if (isSticky) return;

    isSticky = true;
    buttonContainer.classList.add('is-sticky');
    placeholder.style.display = 'block';
  }

  function makeNormal() {
    if (!isSticky) return;

    isSticky = false;
    buttonContainer.classList.remove('is-sticky');
    placeholder.style.display = 'none';
  }

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;

    if (scrollY <= TOP_STICKY) {
      makeSticky();
      return;
    }

    if (scrollY >= hideStickyAt && scrollY <= showStickyAt) {
      makeNormal();
      return;
    }

    if (scrollY > showStickyAt) {
      makeSticky();
    }
  });

  if (window.scrollY <= TOP_STICKY) {
    makeSticky();
  }

  window.addEventListener('resize', () => {
    placeholder.style.height = `${buttonContainer.offsetHeight}px`;
  });
});